import { Component, Prop, Vue, VModel, Watch } from 'vue-property-decorator';
import { OrdersViewModel } from '../models/OrdersViewModel';

import Lister from "./lister";

@Component({
    name: 'history-application',
    components: { Lister },
    template: '#lister'
})
export default class OrdersList extends Vue {
    // define prop
    @Prop({})
    model: OrdersViewModel;

    @Prop({})
    index: number;

    @Prop({})
    pageIndex: number;

    @Prop({})
    itemsOnPage: number;

    @Prop({})
    firstFetchData: any;

    @Prop({})
    currentViewIndex: number;

    @Prop({})
    getOrdersUrl: string;

    @Watch('currentViewIndex', { immediate: true })
    onChildChanged(val: number, oldVal: number) {
        if (val === this.pageIndex) {
            this.currentPage();
        }
        
    }

    @Prop({})
    startFetch: boolean;

    fetchedCurrentPage: any = [];

    async currentPage() {

        if (this.pageIndex === 0) 
            this.fetchedCurrentPage = this.firstFetchData;

        if (this.fetchedCurrentPage && this.fetchedCurrentPage.length > 0)
            return;

        let pageNumber = this.pageIndex + 1;
        this.$emit('progressSwitch', true);
        const fetchURL = this.getOrdersUrl + "?PageNumber=" + pageNumber + '&PageSize=' + this.itemsOnPage;
        const response = await fetch(fetchURL);
        const dataJSON = await response.json();
        const dataCompleted = await dataJSON.Orders;
        this.fetchedCurrentPage = dataCompleted;
        this.$emit('progressSwitch', false);
    }

}
